/**
 * Retain only state IDs, so stale thread responses cannot reopen a card.
 * A card shows the half that its data-view-once-state selects (pm/partials/message-body.twig).
 */
export class ViewOnceCardState {
  constructor() {
    this.opened = new Map();
  }

  receive(detail) {
    if (detail?.state !== 'opened' || !['thread_id', 'message_id', 'media_id'].every(
      key => typeof detail[key] === 'string' && /^[0-9]+$/.test(detail[key])
    )) return false;
    this.opened.set(detail.media_id, detail.message_id);
    return true;
  }

  /** Makes a card openable again, unless a socket event reported its view. */
  reopen(card, prior) {
    if (this.opened.has(card.dataset.viewOnceId) || card.dataset.viewOnceState !== 'opened') return;
    if (prior.state === undefined) delete card.dataset.viewOnceState;
    else card.dataset.viewOnceState = prior.state;
    card.disabled = false;
  }

  apply(root) {
    if (this.opened.size === 0) return;
    for (const card of root.querySelectorAll('[data-view-once-id]')) {
      const messageId = this.opened.get(card.dataset.viewOnceId);
      if (!messageId || card.closest('.pm_msg')?.id !== 'msg_' + messageId) continue;
      // A server-unavailable card keeps its state. It must never read as opened.
      if (['opened', 'unavailable'].includes(card.dataset.viewOnceState)) continue;
      card.dataset.viewOnceState = 'opened';
      card.disabled = true;
    }
  }
}
